import React, { useEffect, useState } from 'react'
import { GalleryStyles as styles } from "./chat.tailwind";
import { Close } from '@mui/icons-material';
import { Skeleton } from '@mui/material';

const VideoPreview = ({ url, isRejected = false, uploadProgress, insideGallery = false, isFullScreen, toggleFullScreen }) => {
    const [isLoading, setIsLoading] = useState(true);

    const getStyle = () => {
        if (insideGallery) {
            return '210px';
        } else {
            if (isRejected) {
                return '100%';
            } else if (uploadProgress?.isUploading) {
                return '70%';
            } else {
                return '100%';
            }
        }
    }

    useEffect(() => {
        if (isFullScreen) {
            document.body.style.overflow = 'hidden';

            // Add ESC key listener
            const handleEscKey = (event) => {
                if (event.key === 'Escape') {
                    toggleFullScreen();
                }
            };

            document.addEventListener('keydown', handleEscKey);

            // Cleanup
            return () => {
                document.body.style.overflow = 'auto';
                document.removeEventListener('keydown', handleEscKey);
            };
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isFullScreen, toggleFullScreen]);

    if (isFullScreen) {
        return (
            <div className={styles.fullScreenContainer}>
                <button
                    onClick={toggleFullScreen}
                    className={styles.fullScreenCloseButton}
                >
                    <Close size={24} />
                </button>
                {
                    isLoading && (
                        <Skeleton
                            variant="rounded"
                            width="100%"
                            height="90%"
                            animation="wave"
                            sx={{ bgcolor: 'grey.700' }}
                        />
                    )
                }
                <video
                    controls
                    alt="Full Screen Preview"
                    className={styles.fullScreenFile}
                    onLoadedData={() => setIsLoading(false)}
                >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        );
    }

    return (
        <>
            {/* {
                isLoading && (
                    <Skeleton
                        variant="rounded"
                        width="100%"
                        height="90%"
                        animation="wave"
                        sx={{ bgcolor: 'grey.700' }}
                    />
                )
            } */}
            <video
                controls
                alt="Video Preview"
                onClick={toggleFullScreen}
                className={styles.previewFile}
                style={{
                    height: getStyle()
                }}
                onLoadedData={() => setIsLoading(false)}
            >
                <source src={url} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </>
    )
}

export default VideoPreview